import { Icon, IconProps } from "@chakra-ui/react";

const XpPoint = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <path
        d="M12 6.7L13.45 10.55L17.3 12L13.45 13.45L12 17.3L10.55 13.45L6.7 12L10.55 10.55L12 6.7ZM12 1L9 9L1 12L9 15L12 23L15 15L23 12L15 9L12 1Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export default XpPoint;
